// Event bus is being used as a hook for pusher updates
//
// Example Useage:
// eventBus.$on('market.pipeline.removeFromCollection', () => {
//  ... Your code
// });
// 
// Current hooks: 
// market.pipeline.removeFromCollection
// market.pipeline.addToCollection
//

import Vue from 'vue';
export const eventBus = new Vue();
